import apis from './apis';

export const fetchConfigByPath = (query, options) =>
  apis.get('config/', {
    query,
    options,
  });
